import React from 'react';
import PropTypes from 'prop-types';
import BaseMarker from '../BaseMarker';
import {getPointSymbol, MAP_PIN_TYPES} from '../../../utils/markers';

const POINT_COLORS = {
    DARK_BLUE: '#15326f',
    ORANGE: '#E85F24',
    WHITE: '#FFFFFF',
};

const PointOfInterestMarker = ({
    position,
    label,
    zIndex,
    onClick,
    isHighlighted,
    isSelected,
    map,
    onHover,
    onHoverLeave,
    infoWindowOptions,
    hoveredMarker,
}) => {
    return (
        <BaseMarker
            map={map}
            position={position}
            label={{
                color: '#FFF',
                text: label,
                fontSize: '12px',
                fontWeight: 'bold',
            }}
            zIndex={zIndex}
            icon={{
                ...getPointSymbol(
                    isHighlighted || isSelected
                        ? POINT_COLORS.DARK_BLUE
                        : POINT_COLORS.ORANGE,
                    isHighlighted || isSelected ? 1.06 : 1
                ),
                anchor: {x: 7, y: 1},
            }}
            onClick={onClick}
            onHover={onHover}
            onHoverLeave={onHoverLeave}
            isHighlighted={isHighlighted}
            hoveredMarker={hoveredMarker}
            isSelected={isSelected}
            infoWindowOptions={infoWindowOptions}
            pinType={MAP_PIN_TYPES.POI}
        />
    );
};

export default PointOfInterestMarker;

PointOfInterestMarker.propTypes = {
    map: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    position: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
    }).isRequired,
    labelText: PropTypes.string,
    isHighlighted: PropTypes.bool,
    zIndex: PropTypes.number,
};
